import { Component, inject, input, output, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '../../../forms/button/button.component';
import { TooltipDirective } from '../../../tooltip/tooltip.directive';
import { ThemeService } from '../../../theme/theme.service';
import type { Theme } from '../../../theme/theme.service';

@Component({
    selector: 'app-footer-cabinet',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [ButtonComponent, TooltipDirective, RouterLink]
})
export class FooterCabinetComponent {
    private readonly themeService = inject(ThemeService);
    readonly isDesktop = !!(window as unknown as Record<string, unknown>)['electronAPI'];

    aboutUrl = input('https://infinitform.com/about/');
    eulaUrl = input('https://infinitform.com/eula/');
    privacyUrl = input('https://infinitform.com/privacy-policy/');
    showFeedback = input(false);
    helpRoute = input('/user/help');

    feedbackClick = output<void>();

    readonly currentYear = new Date().getFullYear();

    getCurrentTheme(): Theme {
        return this.themeService.getCurrentTheme();
    }

    changeTheme(theme: Theme): void {
        this.themeService.setTheme(theme);
    }

    onFeedbackClick(): void {
        this.feedbackClick.emit();
    }
}
